﻿export * from './user.component';
export * from './update-user.component';